// API Configuration
const config = {
  // API Base URL
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: '/api/auth/login',
      REGISTER: '/api/auth/register',
      REFRESH: '/api/auth/refresh',
      LOGOUT: '/api/auth/logout',
      RESET_PASSWORD: '/api/auth/reset-password',
      REQUEST_RESET: '/api/auth/request-reset',
      CONFIRM_EMAIL: '/api/auth/confirm-email',
    },
    
    // Horses
    HORSES: {
      BASE: '/api/horses',
      INFO: (id) => `/api/horses/${id}`,
      VACCINATIONS: (id) => `/api/horses/${id}/vaccinations`,
      BREEDINGS: (id) => `/api/horses/${id}/breedings`,
      HOOF_CARE: (id) => `/api/horses/${id}/hoofcare`,
      DENTAL_CARE: (id) => `/api/horses/${id}/dentalcare`,
      DEWORMING: (id) => `/api/horses/${id}/deworming`,
      MEDICAL_HISTORY: (id) => `/api/horses/${id}/medicalhistory`,
    },
    
    // Calendar
    CALENDAR: {
      EVENTS: '/api/calendar/events',
      WEBHOOK: '/api/calendar/webhook',
      WEBHOOK_EVENTS: '/api/calendar/webhook-events',
    },
    
    // Entries
      ENTRIES: {
    BASE: '/api/entries',
    SQLSERVER: '/api/sqlserver-entries',
  },
    
    // Results
    RESULTS: {
      BASE: '/api/results',
      SQLSERVER: '/api/sqlserver-results',
    },
    
    // Profile & Settings
    PROFILE: '/api/profile',
    SETTINGS: '/api/settings',
    SUBSCRIPTIONS: '/api/subscriptions',
    VETERINARIANS: '/api/veterinarians',
    CONNECT: '/api/connect',
  },
  
  // Request Configuration
  REQUEST_CONFIG: {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 30000, // 30 seconds
  },
  
  // Environment
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  IS_PRODUCTION: process.env.REACT_APP_ENVIRONMENT === 'production',
  
  // Google Maps
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${config.API_BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    ...config.REQUEST_CONFIG.headers,
    Authorization: token ? `Bearer ${token}` : '',
    'x-api-key': process.env.REACT_APP_API_KEY || 'your-api-key-here',
  };
};

export default config;
